import { ApiError } from '../api/client'

/**
 * Translate a coworker print API error into a user-facing string.
 *
 * The API envelope shape is `{ error, code, message }` per the design's
 * "Error contract (coworker SPA)" table — the SPA looks up UX copy keyed
 * by `code`. If no copy exists for the code, fall back to the server's
 * `message`, then to the raw code, then to a generic "something went
 * wrong" string.
 *
 * Extracted from `PrintCenterPage.tsx` + `PrintReleasePage.tsx` so both
 * pages share a single source of truth.
 */
export function describePrintError(err: unknown, t: (key: string) => string): string {
  if (err instanceof ApiError) {
    const body = (err.body ?? {}) as { code?: string; message?: string }
    const code = body.code ?? err.message
    const translated = t(`print.errors.${code}`)
    if (translated && translated !== `print.errors.${code}`) return translated
    if (body.message) return body.message
    return code || t('common.error')
  }
  return t('common.error')
}
